<if(input.edit || input.cancel || input.save)>
    <div class="str-profile-edit-buttons">
        <!--============
        // Mobile
        ================-->
        <if(input.isSmall)>
            <if(input.mobileView === 'edit' && !input.profileEditState?.editing)>
                <edit input=input type='mobile-edit'/>
            </if>
            <else-if(input.mobileView === 'save-and-cancel' && input.profileEditState?.editing)>
                <cancel input=input/>
                <save input=input/> 
            </else-if>
        </if>
        <else>
            <!--============
            // Desktop
            ================-->
            <if(!input.profileEditState?.editing)>
                <edit input=input/>
            </if>
            <else>
                <cancel input=input/>
                <save input=input/>
            </else>
        </else>
    </div>
</if>

<macro|{ input, type }| name="edit">
    <if(input.edit)>
        <if(type === 'mobile-edit')>
            <ebay-button class="str-profile-edit-buttons__edit-mobile"
                priority="secondary"
                data-track=input.edit.tracking
                 on-click("presenceEditAction", input.edit.action)>
                ${input.edit.text}
            </ebay-button>
        </if>
        <else>
            <button class="str-profile-edit-buttons__edit"
                data-track=input.edit.tracking
                on-click("presenceEditAction", input.edit.action)>
                <span class="str-profile-edit-buttons__edit-icon">
                    <ebay-pencil-16-icon />
                </span>
                <span class="str-profile-edit-buttons__edit-text">
                    ${input.edit.text}
                </span>
            </button>
        </else>
    </if>
</macro>

<macro|{ input }| name="cancel">
    <if(input.cancel)>
        <ebay-button
            class="str-profile-edit-buttons__cancel"
            data-track=input.cancel.tracking
            priority=input.cancel.priority
            on-click("presenceEditAction", input.cancel.action)>
            ${input.cancel.text}
        </ebay-button>
    </if>
</macro>

<macro|{ input }| name="save">
    <if(input.save)>
        <ebay-button
            class="str-profile-edit-buttons__save"
            data-track=input.save.tracking
            priority=input.save.priority
            disabled=input.profileEditState?.saving
            on-click("presenceEditAction", input.save.action)>

            <if(!input.profileEditState?.saving)>
                ${input.save.text}
            </if>
            <else>
                <ebay-progress-spinner size="small" aria-live="polite" />
            </else>
        </ebay-button>
    </if>
</macro>
